var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.key == null)?_c('loader'):_c('base-single-key-rp',{attrs:{"code":_vm.key,"index":_vm.index,"url":_vm.url},on:{"backToLesson":_vm.backToLesson,"stopRegistration":_vm.stopRegistration}})
}
var staticRenderFns = []

export { render, staticRenderFns }